import { render, staticRenderFns } from "./foip-info.vue?vue&type=template&id=775cb4b8&"
import script from "./foip-info.vue?vue&type=script&lang=js&"
export * from "./foip-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports